import { array, func, object, node } from 'prop-types'
import { useState } from 'react'
import { kuiperClassNames, PopoverV2 } from '@opallabs/kuiper'
import AccessRequestForm from './AccessRequestForm'

import './styles.scss'

const hasCurrentError = (errors) =>
  (errors && errors.length && errors[0].type === 'requestPrivacyGroupAccess') ||
  null

const isPendingUser = (entity, user) => {
  const pendingMembers = entity.privacy_group.pending_members
  return (
    user &&
    pendingMembers &&
    pendingMembers.some(
      (member) =>
        member.status === 'pending' && parseInt(member.user.id, 10) === user.id
    )
  )
}

const AccessRequestPopover = ({
  children,
  entity,
  errors,
  me,
  onDismissError,
  onRequestAccess,
}) => {
  const [hasRequestedAccess, setRequestedAccess] = useState(false)
  const [isOpen, setOpen] = useState(false)
  const userIsPending = hasRequestedAccess || isPendingUser(entity, me)

  return (
    <PopoverV2
      className="accessRequestTippy"
      forceClose={!isOpen}
      triggerEvent="click"
      onOpened={() => setOpen(true)}
      onClosed={() => {
        if (hasCurrentError(errors)) {
          setOpen(false)
          onDismissError(errors[0])
        }
      }}
      trigger={children}
      edgeOffset={0}
      position="bottom"
      content={
        <div className={kuiperClassNames('accessRequestPopover')}>
          <div className={kuiperClassNames('accessRequestPopover-heading')}>
            This moment is private
          </div>
          <div
            className={kuiperClassNames('accessRequestPopover-footer', {
              'accessRequestPopover-requested': userIsPending,
            })}
          >
            <AccessRequestForm
              forceClose={() => setOpen(false)}
              accessRequested={userIsPending}
              hasCurrentError={hasCurrentError(errors)}
              onRequestAccess={(message) => {
                setOpen(true)
                setRequestedAccess(true)
                onRequestAccess(message)
              }}
            />
          </div>
        </div>
      }
    />
  )
}

AccessRequestPopover.propTypes = {
  children: node,
  entity: object,
  errors: array,
  me: object,
  onDismissError: func,
  onRequestAccess: func,
}

export default AccessRequestPopover
